import { Link } from "react-router-dom";

const entries = [
  {
    to: "/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "最新上映 · 高分佳作",
    count: "1200+ 部",
  },
  {
    to: "/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "热播剧集 · 全集资源",
    count: "860+ 部",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "资讯",
    desc: "行业动态 · 热点速递",
    count: "每日更新",
  },
  {
    to: "/special",
    icon: "ri-book-open-line",
    title: "专题",
    desc: "深度评论 · 影视解说",
    count: "520+ 篇",
  },
];

export default function CategoryEntries() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {entries.map((entry) => (
            <Link
              key={entry.to}
              to={entry.to}
              className="group rounded-lg bg-background-100 border border-background-200 p-5 md:p-6 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center group-hover:bg-accent-500 group-hover:text-foreground-950 transition-colors">
                <i className={`${entry.icon} text-2xl md:text-3xl`} />
              </span>
              <h3 className="mt-4 md:mt-5 font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">
                {entry.title}
              </h3>
              <p className="mt-1.5 text-xs md:text-sm text-foreground-600">{entry.desc}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-900">
                  {entry.count}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-500 transition-colors" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}